import { LabelDeviation } from '../../../../../Interface/Hook/Interest/InterestTableDTO';
import ChangeIcon from './ChangeIcon';
import { NewsType } from '../../../../../Enum/Interest/NewsType';
import React from 'react';

interface Props {
    label: LabelDeviation;
}

const ProductDeviation: React.FC<Props> = ({ label }: Props) => (
    <div>
        {' '}
        <ChangeIcon type={label.type as NewsType} /> {label.label}{' '}
    </div>
);

export default ProductDeviation;
